export default __webpack_public_path__ + "static/MineralSwimV2_HomePage_BCKWITHICONS-1cd5923075cac60374b8eca228c9b1c3.jpeg";